export default "insights";
